export const aiCoPilotCards = [
  {
    id: 1,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881564/cr-img-one_imzidy.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881565/cr-img-one-af_jbr9cr.webp",
    title: "Natural Language Understanding (NLU)",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881570/cr-img-two_dqybiu.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881571/cr-img-two-af_jfz61r.webp",
    title: "Contextual Awareness",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881568/cr-img-three_pbodkq.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881570/cr-img-three-af_gmovhk.webp",
    title: "Conversational Memory",
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881560/cr-img-four_rmwecn.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881560/cr-img-four-af_f6dj4k.webp",
    title: "Multimodal Input (voice, text, images)",
  },
];

export const aiCoPilotCardsTwo = [
  {
    id: 1,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881560/cr-img-five_wed1q0.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881560/cr-img-five-af_kz8muk.webp",
    title: "Custom Prompt Templates",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881566/cr-img-six_gajtxv.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881567/cr-img-six-af_deayvx.webp",
    title: "Learning from User Behavior",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881565/cr-img-seven_su1ifn.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881565/cr-img-seven-af_egsroa.webp",
    title: "Real-Time Decision Making",
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881560/cr-img-eight_nizcow.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746881560/cr-img-eight-af_t93agh.webp",
    title: "Data Privacy Controls",
  },
];

export const aiCoPilotKeyCards = [
  {
    img: require("../../../image/aicopilot/key-img-one.webp"),
    title: "Natural Language Understanding (NLU)",
  },
  {
    img: require("../../../image/aicopilot/key-img-two.webp"),
    title: "Contextual Assistance",
  },
  {
    img: require("../../../image/aicopilot/key-img-three.webp"),
    title: "Multi-channel Integration",
  },
  {
    img: require("../../../image/aicopilot/key-img-four.webp"),
    title: "Voice and Text Interactions",
  },
  {
    img: require("../../../image/aicopilot/key-img-five.webp"),
    title: "Task Automation",
  },
  {
    img: require("../../../image/aicopilot/key-img-six.webp"),
    title: "Continuous Learning",
  },
];

export const aiCopilotBenefits = [
  {
    img: require("../../../image/aicopilot/ben-img-one.webp"),
    title: "AI Copilot Solutions",
    description:
      "Develop AI copilots customized to your unique business goals and workflows.",
  },
  {
    img: require("../../../image/aicopilot/ben-img-two.webp"),
    title: "Scalable by Design",
    description:
      "Build copilots that seamlessly scale alongside your business growth and evolving needs.",
  },
  {
    img: require("../../../image/aicopilot/ben-img-three.webp"),
    title: "Enterprise-Grade Security",
    description:
      "Protect sensitive data and stay aligned with industry regulations through robust security practices.",
  },
  {
    img: require("../../../image/aicopilot/ben-img-four.webp"),
    title: "Work with AI Experts",
    description:
      "Partner with experienced data scientists, AI engineers, and product strategists to bring your vision to life.",
  },
];

export const aiCopilotUseCases = [
  {
    img: require("../../../image/aicopilot/use-img-one.webp"),
    title: "Customer Support Copilot",
    features: [
      "Real-time ticket resolution",
      "FAQ automation",
      "Sentiment analysis",
    ],
  },
  {
    img: require("../../../image/aicopilot/use-img-two.webp"),
    title: "Sales & Marketing Copilot",
    features: [
      "Email campaign suggestions",
      "CRM updates",
      "Customer segmentation",
    ],
  },
  {
    img: require("../../../image/aicopilot/use-img-three.webp"),
    title: "Developer Copilot",
    features: [
      "Code generation",
      "Bug fixing suggestions",
      "Documentation assistance",
    ],
  },
  {
    img: require("../../../image/aicopilot/use-img-four.webp"),
    title: "HR & Talent Copilot",
    features: [
      "Resume screening",
      "Interview scheduling",
      "Employee onboarding",
    ],
  },
  {
    img: require("../../../image/aicopilot/use-img-five.webp"),
    title: "Legal & Compliance Copilot",
    features: ["Document analysis", "Risk assessments", "Regulation updates"],
  },
  {
    img: require("../../../image/aicopilot/use-img-six.webp"),
    title: "Content Creation Copilot",
    features: [
      "Blog and copy generation",
      "Social media post assistance",
      "SEO content suggestions",
    ],
  },
];

export const aiCopilotIndustries = [
  {
    img: require("../../../image/aicopilot/ind-img-one.webp"),
    title: "Healthcare",
    desc: "Medical transcription, patient support",
  },
  {
    img: require("../../../image/aicopilot/ind-img-two.webp"),
    title: "Finance",
    desc: "Fraud detection, customer support",
  },
  {
    img: require("../../../image/aicopilot/ind-img-three.webp"),
    title: "Retail",
    desc: "Inventory management, personalized shopping",
  },
  {
    img: require("../../../image/aicopilot/ind-img-four.webp"),
    title: "Education",
    desc: "Tutoring, grading assistance",
  },
  {
    img: require("../../../image/aicopilot/ind-img-five.webp"),
    title: "Legal",
    desc: "Document analysis, case research",
  },
  {
    img: require("../../../image/aicopilot/ind-img-six.webp"),
    title: "Manufacturing",
    desc: "Predictive maintenance, quality control",
  },
];

export const aiCopilotProcessSteps = [
  {
    img: require("../../../image/aicopilot/process-img-one.webp"),
    title: "Discovery Phase",
    desc: "Understanding your business goals",
  },
  {
    img: require("../../../image/aicopilot/process-img-two.webp"),
    title: "Data Collection & Preparation",
    desc: "Gathering relevant datasets",
  },
  {
    img: require("../../../image/aicopilot/process-img-three.webp"),
    title: "Model Selection",
    desc: "Building the AI engine",
  },
  {
    img: require("../../../image/aicopilot/process-img-four.webp"),
    title: "UI/UX Design",
    desc: "Creating a user-friendly interface",
  },
  {
    img: require("../../../image/aicopilot/process-img-five.webp"),
    title: "Integration",
    desc: "Connecting the copilot with your existing systems",
  },
  {
    img: require("../../../image/aicopilot/process-img-six.webp"),
    title: "Testing and QA",
    desc: "Ensuring performance and accuracy",
  },
  {
    img: require("../../../image/aicopilot/process-img-seven.webp"),
    title: "Deployment",
    desc: "Launching the AI copilot",
  },
  {
    img: require("../../../image/aicopilot/process-img-eight.webp"),
    title: "Monitoring and Iteration",
    desc: "Continuous improvement",
  },
];

export const technologiesData = [
  {
    id: "machinelearning",
    label: "Machine Learning",
    data: [
      {
        id: 1,
        icon: require("../../../image/aicopilot/tensorflow.webp"),
        title: "TensorFlow",
      },
      {
        id: 2,
        icon: require("../../../image/aicopilot/pytorch.webp"),
        title: "PyTorch",
      },
    ],
  },
  {
    id: "nlp",
    label: "NLP",
    data: [
      {
        id: 1,
        icon: require("../../../image/aicopilot/gpt.webp"),
        title: "GPT",
      },
      {
        id: 2,
        icon: require("../../../image/aicopilot/bert.webp"),
        title: "BERT",
      },
      {
        id: 3,
        icon: require("../../../image/aicopilot/spacy.webp"),
        title: "spaCy",
      },
    ],
  },
  {
    id: "cloudplatforms",
    label: "Cloud Platforms",
    data: [
      {
        id: 1,
        icon: require("../../../image/aicopilot/aws.webp"),
        title: "AWS",
      },
      {
        id: 2,
        icon: require("../../../image/aicopilot/cloud.webp"),
        title: "Google Cloud",
      },
      {
        id: 3,
        icon: require("../../../image/aicopilot/azure.webp"),
        title: "Azure",
      },
    ],
  },
  {
    id: "databases",
    label: "Databases",
    data: [
      {
        id: 1,
        icon: require("../../../image/aicopilot/mongodb.webp"),
        title: "MongoDB",
      },
      {
        id: 2,
        icon: require("../../../image/aicopilot/postgresql.webp"),
        title: "PostgreSQL",
      },
    ],
  },
  {
    id: "devops",
    label: "DevOps Tools",
    data: [
      {
        id: 1,
        icon: require("../../../image/aicopilot/docker.webp"),
        title: "Docker",
      },
      {
        id: 2,
        icon: require("../../../image/aicopilot/kubernetes.webp"),
        title: "Kubernetes",
      },
    ],
  },
];

export const aiTrends = [
  {
    img: require("../../../image/aicopilot/trend-img-one.webp"),
    title: "Generative AI for Content Creation",
  },
  {
    img: require("../../../image/aicopilot/trend-img-two.webp"),
    title: "Voice-Enabled AI Assistants",
  },
  {
    img: require("../../../image/aicopilot/trend-img-three.webp"),
    title: "AI-Powered Predictive Insights",
  },
  {
    img: require("../../../image/aicopilot/trend-img-four.webp"),
    title: "Context-Aware Task Management",
  },
  {
    img: require("../../../image/aicopilot/trend-img-five.webp"),
    title: "Integration with Wearables and IoT",
  },
];

export const costFactors = [
  {
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879627/cost-img-one_bvssqr.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879627/cost-img-one-af_l1jase.webp",
    title: "Project Complexity",
  },
  {
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879632/cost-img-two_l7onc2.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879633/cost-img-two-af_yaurqi.webp",
    title: "Features and Customization",
  },
  {
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879627/cost-img-three_jqnzdq.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879632/cost-img-three-af_usmyow.webp",
    title: "Data Requirements",
  },
  {
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879626/cost-img-four_eubmwj.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879627/cost-img-four-af_sjgwhx.webp",
    title: "Integration Needs",
  },
  {
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879626/cost-img-five_rvjs2b.webp",
    hoverImg:
      "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746879627/cost-img-five-af_js46bs.webp",
    title: "Maintenance and Support Plans",
  },
];

export const hireFactors = [
  "Portfolio & Case Studies",
  "Client Testimonials",
  "Technology Stack",
  "Customizability",
  "Pricing Model",
  "Support and Maintenance Plans",
];
